import React from 'react'
import { useQuery } from '@tanstack/react-query'
import VouchersAPI from 'api/faber/VouchersAPI'
import MUIDataGrid from 'common/AbstractDataGrid/DataGridMUI'
import { subMonths } from 'date-fns'
import format from 'date-fns/format'
import OrbitSession from 'hooks/useCookies'

const voucherColumns = [
    {
        field: 'code',
        headerName: 'Code',
        sortable: false,
        minWidth: 100
    },
    {
        field: 'name',
        headerName: 'Reward Name',
        sortable: false,
        minWidth: 300
    },
    {
        field: 'issued_at',
        headerName: 'Issued At',
        minWidth: 100,
        valueFormatter: ({ value }) => {
            return format(new Date(value), 'dd MMM yyyy HH:mm')
        }
    },
    {
        field: 'expiry_at',
        headerName: 'Expiry At',
        minWidth: 100,
        valueFormatter: ({ value }) => {
            return format(subMonths(new Date(value), 3), 'dd MMM yyyy HH:mm')
        }
    },
    {
        field: 'voucher_type',
        headerName: 'Voucher Type',
        sortable: false,
        minWidth: 100
    }
]

function JetpassVoucherTable({ userId, isExternal }: { userId: string, isExternal: boolean }) {
    const faberToken = OrbitSession.get('faberToken')

    const { data: allVouchers } = useQuery(
        ['userVoucherData', userId],
        async () => {
            return isExternal ?
                VouchersAPI.getExternalAllVoucher(
                    faberToken,
                    userId
                )
                :
                VouchersAPI.getAllVoucher(
                    faberToken,
                    userId
                )
        }
    )

    return (
        <>
            <MUIDataGrid
                columns={voucherColumns}
                rows={allVouchers ? allVouchers.body.data : []}
                getRowId={(row) => row.ID}
            />
        </>
    )
}

export default JetpassVoucherTable
